import { PaginationValues } from "../../types/General/PaginationValues";
import { Indicator } from "../../types/Indicator/Indicator";
import api from "../../utils/api";
import { INDICATOR_URL } from "../../utils/endpoints";

export async function getIndicator(
  id?: string,
  filterValues?: any,
  paginationValues?: PaginationValues,
) {
  try {
    const response = await api.get(
      id ? `${INDICATOR_URL}/${id}` : `${INDICATOR_URL}`,
      {
        params: {
          ...filterValues,
          ...paginationValues,
        },
      },
    );
    const data: Indicator[] = id
      ? response.data.name
      : response.data.result.map((option: Indicator) => ({
          id: option.id,
          name: option.name,
          type: option.type,
          subSystem: option.subSystem,
          frequency: option.frequency,
          readingVariation: option.readingVariation,
          level: option.level,
          alertState: option.alertState ?? null,
          reference: option.reference ?? null,
          partner: option.partner,
          collectionType: option.collectionType,
          metric: option.metric,
          anotherMetric: option.anotherMetric ?? null,
          state: option.state ?? null,
        }));
    return { content: data, totalItems: response.data.totalItems };
  } catch (error) {
    throw error;
  }
}
